import React from "react";
import { GALLERY } from "../lib/site";

export default function Impact() {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative py-20 sm:py-32 bg-[#064E3B] text-white overflow-hidden"
    >
      <div className="absolute inset-0 geo-overlay-light opacity-40 pointer-events-none" />
      <div className="absolute -top-32 -right-32 h-80 w-80 rounded-full bg-[#065F46] blur-3xl opacity-60" />
      <div className="absolute -bottom-40 -left-32 h-96 w-96 rounded-full bg-[#0b6b4f] blur-3xl opacity-40" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.24em] font-semibold text-[#FCD34D]">
              Our Impact
            </div>
            <div className="mt-4 w-16 h-[3px] rounded-full bg-gradient-to-r from-[#FCD34D] to-[#DC2626]" />
            <h2 className="font-serif-display text-3xl sm:text-5xl mt-6 leading-[1.1] font-semibold">
              Numbers that carry{" "}
              <span className="italic text-[#FCD34D]">human stories.</span>
            </h2>
            <p className="mt-5 sm:mt-6 text-white/80 text-base sm:text-lg leading-relaxed max-w-xl">
              Each life we touch is a meal served, a child schooled, a widow rehoused, a
              prescription filled. Behind every count is a name we honour and remember.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div
              data-testid="stat-beneficiaries"
              className="rounded-3xl bg-white/8 border border-white/15 backdrop-blur-sm p-8 sm:p-10"
            >
              <div className="font-serif-display text-6xl sm:text-8xl text-[#FCD34D] font-semibold leading-none">
                100+
              </div>
              <div className="mt-3 sm:mt-4 text-[11px] uppercase tracking-[0.18em] text-white/80 font-semibold">
                Beneficiaries reached
              </div>
            </div>
          </div>
        </div>

        {/* Gallery strip */}
        <div className="mt-14 sm:mt-20">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#FCD34D] font-semibold mb-5 sm:mb-6">
            From the field
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
            {GALLERY.map((src, i) => (
              <div
                key={src}
                data-testid={`gallery-${i}`}
                className={`relative overflow-hidden rounded-2xl border border-white/10 group ${
                  i === 0 ? "col-span-2 row-span-2 md:col-span-2" : ""
                }`}
              >
                <img
                  src={src}
                  alt={`Field photo ${i + 1}`}
                  className="h-full w-full object-cover aspect-square transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#064E3B]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
